import {Controller} from "stimulus"

export default class extends Controller {
    static targets = ['endDate', 'addExtraBtn', 'holes', 'drills']

    connect() {
        if (this.hasEndDateTarget) {
            let endDateInput = this.endDateTarget
            if (endDateInput) {
                this.endDate = endDateInput.value
            }
        }
    }

    showInvoice(ev) {
        if (ev.target.tagName != 'DIV') {
            return false
        }
        window.location.href = ev.currentTarget.closest('li').dataset.url
    }

    editExtra(ev) {
        if ((ev.currentTarget.dataset.editing == "1") || (ev.target.closest('[form="invoice"]') != null)) {
            return
        }

        ev.preventDefault()
        ev.stopPropagation()

        ujs.ajax({
            url: ev.currentTarget.dataset.url,
            type: 'get',
            dataType: 'script'
        })
    }

    updateDefaultExtraDate(ev) {
        let date = ev.currentTarget.value

        if (date) {
            this.endDate = date
        }
    }

    deleteExtra(ev) {
        ev.preventDefault()
        ev.stopPropagation()

        if (confirm(ev.currentTarget.dataset.confirmMessage)) {
            ujs.ajax({
                url: ev.currentTarget.dataset.url,
                type: 'DELETE',
                dataType: 'script'
            })
        }
    }

    resetHoles(ev) {
        this.resetChoices(this.holesTarget, ev.currentTarget)
    }

    resetDrills(ev) {
        this.resetChoices(this.drillsTarget, ev.currentTarget)
    }

    set endDate(val) {
        let btn = this.addExtraBtnTarget

        if (btn) {
            btn.dataset.params = JSON.stringify({
                date: val
            })
        }
    }

    // Generic reset function for both self and related target dropdowns (e.g. holes and drills)
    resetChoices(targetEl, currentEl) {
        const relatedSelectController = this.application.getControllerForElementAndIdentifier(targetEl, 'select')
        const currentSelectController = this.application.getControllerForElementAndIdentifier(currentEl, 'select')

        relatedSelectController.removeActiveItems()
        relatedSelectController.updatePlaceholder()
        currentSelectController.updatePlaceholder()
    }
}
